import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FormControl, Grid } from '@mui/material';
import { StyledSwitch, StyledSwitchLabel } from './switch-field.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Icon button component.
 *
 * @author Elena Shymanskaya
 * @function Switch
 * @category components
 * @return {JSX.Element} switch component.
 */
export var Switch = function Switch(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      label = _ref.label,
      fullWidth = _ref.fullWidth,
      labelProps = _ref.labelProps,
      fieldProps = _ref.fieldProps,
      containerProps = _ref.containerProps,
      onFocus = _ref.onFocus,
      name = _ref.name,
      checked = _ref.checked,
      disabled = _ref.disabled;
  var inputName = name && "".concat(name, "-switch");
  return /*#__PURE__*/_jsx(FormControl, {
    fullWidth: fullWidth,
    children: /*#__PURE__*/_jsxs(Grid, _objectSpread(_objectSpread({
      container: true,
      rowSpacing: 1,
      columnSpacing: 2,
      alignItems: "center"
    }, containerProps), {}, {
      children: [label && /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true
      }, labelProps), {}, {
        children: /*#__PURE__*/_jsx(StyledSwitchLabel, {
          component: "label",
          htmlFor: inputName,
          children: label
        })
      })), /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true,
        flex: "1 1"
      }, fieldProps), {}, {
        children: /*#__PURE__*/_jsx(StyledSwitch, {
          onChange: onChange,
          value: Boolean(value),
          id: inputName,
          checked: checked,
          onFocus: onFocus,
          disabled: disabled
        })
      }))]
    }))
  });
};